<template>
  <div
    class="nx-form-combination-select-wrapper"
    v-validate="validation"
    :data-vv-name="name"
    :data-vv-scope="scope"
    :data-vv-as="label"
    data-vv-value-path="value"
    data-vv-validate-on="input|blur"
  >
    <template
      v-for="(selector, selectorIndex) in preparedValue"
    >
      <v-layout
        v-if="selectorIndex > 0"
        :key="`selector-btn-${selectorIndex}`"
        class="justify-center">
        <v-chip>
          {{ $t('message.combinationSelect.or') }}
        </v-chip>
      </v-layout>
      <v-layout :key="`selector-${selectorIndex}`">
        <v-flex xs11>
          <v-autocomplete
            chips multiple
            :items="items"
            :value="selector"
            :label="label"
            v-bind="$attrs"
            @input="onSelectorInput(selectorIndex, $event)"
          >
            <template #selection="{ parent, item, index, selected, disabled }">
              <v-chip
                v-if="index > 0"
                color="transparent">
                {{ $t('message.combinationSelect.and') }}
              </v-chip>
              <v-chip
                close
                @input="onItemRemoveIndex(selectorIndex, parent.getValue(item))"
                :selected="selected"
                :disabled="disabled"
                :text="parent.getText(item)"
              >
                {{ parent.getText(item) }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex class="xs1 align-self-center text-xs-center">
          <v-btn icon @click="onSelectorClear(selectorIndex)">
            <v-icon color="primary">delete</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <v-btn
      block outline color="primary"
      :disabled="disableNewSelectorButton"
      @click="addNewSelector"
    >
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'nx-form-combination-select',
  extends: {},
  mixins: [FormElement],
  components: {},
  props: {
    value: {
      type: Array,
      validator(value) {
        return Array.isArray(value)
          && value.every(selector => Array.isArray(selector));
      },
      default: () => ([]),
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    preparedValue() {
      if (!Array.isArray(this.value)) {
        return [[]];
      }
      if (this.value.length === 0) {
        return [[]];
      }
      return this.value;
    },
    disableNewSelectorButton() {
      return this.preparedValue.some(values => values.length === 0);
    },
    count() {
      return this.preparedValue.length;
    },
  },
  watch: {},
  methods: {
    onSelectorInput(selectorIndex, selectorValue) {
      const value = cloneDeep(this.preparedValue);
      value[selectorIndex] = selectorValue;
      this.onInput(value);
    },
    onSelectorClear(selectorIndex) {
      const value = this.preparedValue.filter((s, index) => index !== selectorIndex);
      this.onInput(value);
    },
    addNewSelector() {
      const value = cloneDeep(this.preparedValue);
      value.push([]);
      this.onInput(value);
    },
    onInput(value) {
      this.$emit('input', value);
      this.$parentForm.updateField(this.name, value);
    },
    onBlur($event) {
      this.$parentForm.updateField(this.name, this.preparedValue);
      this.$emit('blur', $event);
      this.flags.focused = false;
    },
    onItemRemoveIndex(selectorIndex, selectorValue) {
      const value = cloneDeep(this.preparedValue);
      value[selectorIndex] = value[selectorIndex].filter(val => val !== selectorValue);
      this.onInput(value);
    },
  },
  beforeCreate() {
  },
  mounted() {
  },
};
</script>
